(() => {
  const roots = document.querySelectorAll(".nvsv");
  if (!roots.length) return;

  roots.forEach((root) => {
    const bubbles = [...root.querySelectorAll(".nvsv__bubble")];
    let modal = root.querySelector(".nvsvm");
    if (!modal || !bubbles.length) return;

    // TELEPORT: move modal pra dentro do body (fix real do mobile/transform)
    if (!modal.dataset.teleported) {
      modal.dataset.teleported = "1";
      document.body.appendChild(modal);
    }

    const closeEls = modal.querySelectorAll("[data-close]");
    const btnPrev = modal.querySelector("[data-prev]");
    const btnNext = modal.querySelector("[data-next]");
    const video = modal.querySelector(".nvsvm__video");
    const caption = modal.querySelector(".nvsvm__caption");
    const bar = modal.querySelector(".nvsvm__progress span");
    const variantId = Number(root.getAttribute("data-variant-id"));

    let idx = 0;
    let raf = null;

    const stopRAF = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    };

    const tick = () => {
      if (video.duration && !isNaN(video.duration)) {
        bar.style.width = Math.min(100, (video.currentTime / video.duration) * 100) + "%";
      }
      raf = requestAnimationFrame(tick);
    };

    function getStorySrc(b) {
      const source = b.querySelector(".nvsv__hidden source");
      if (source) return source.src || source.getAttribute("src") || "";
      const v = b.querySelector(".nvsv__hidden video");
      if (v) return v.currentSrc || v.src || "";
      return "";
    }

    function lockScroll() {
      document.body.classList.add("nvsv-open");
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }

    function unlockScroll() {
      document.body.classList.remove("nvsv-open");
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }

    function loadStory(i) {
      idx = i;
      stopRAF();
      bar.style.width = "0%";

      const b = bubbles[idx];
      const src = getStorySrc(b);
      const cap = (b.dataset.caption || "").trim();
      if (caption) caption.textContent = cap;

      if (!src) {
        if (idx < bubbles.length - 1) return loadStory(idx + 1);
        return close();
      }

      // reset video
      try { video.pause(); } catch (e) {}
      video.removeAttribute("src");
      video.load();

      video.muted = false;
      video.playsInline = true;
      video.autoplay = true;

      video.src = src;
      video.load();

      video.onloadedmetadata = () => {
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
        stopRAF();
        raf = requestAnimationFrame(tick);
      };

      video.onended = () => {
        if (idx < bubbles.length - 1) loadStory(idx + 1);
        else close();
      };
    }

    function open(i) {
      modal.hidden = false;
      lockScroll();
      loadStory(i);
    }

    function close() {
      stopRAF();
      try { video.pause(); } catch (e) {}
      modal.hidden = true;
      unlockScroll();
    }

    const prev = () => { if (idx > 0) loadStory(idx - 1); };
    const next = () => { if (idx < bubbles.length - 1) loadStory(idx + 1); else close(); };

    // binds
    bubbles.forEach((b, i) => b.addEventListener("click", () => open(i)));
    closeEls.forEach((b) => b.addEventListener("click", close));
    if (btnPrev) btnPrev.addEventListener("click", prev);
    if (btnNext) btnNext.addEventListener("click", next);

    // fecha clicando no overlay (se tiver data-close no overlay, já funciona; mas garante aqui também)
    const overlay = modal.querySelector(".nvsvm__overlay");
    if (overlay) overlay.addEventListener("click", close);

    document.addEventListener("keydown", (e) => {
      if (modal.hidden) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    });
  });
})();
